i18n = {
    "Password_InvalidFormat": "The password must contain a minimum of one lowercase letter, one uppercase letter and one number.",
    "Username_NoSpecialCharacters": "Username can contain letters, numbers, periods and underscores.",
    "SecurityQuestion_AuthInstructions": "Please answer the following security questions to confirm your changes",
    "Field_Required": "This field is required.",
    "PasswordConfirmation_NoMatch": "Please make sure your password confirmation matches."
};